import * as React from 'react';
import { HashTagModel, PostModel } from '../../../../models'
import Controller, { IAbstractDashboardControllerProps } from '../../common/CommonDashboardController';
import View from './DashboardPostsAddEditView';

interface IDashboardPostsAddEditControllerState extends Interfaces.IViewControllerState {
    post: PostModel
    hashTagsSearchResult: HashTagModel[]
    isNextStepAfterPostCreationDialogOpen: boolean
}

class DashboardPostsAddEditController<P, S> extends Controller<P, S & IDashboardPostsAddEditControllerState> {

    public static defaultProps: Partial<IAbstractDashboardControllerProps> = {
        title: 'Создание поста'
    }

    constructor(props: any) {
        super(props)
        this.state = {
            logicError: '',
            post: new PostModel(),
            hashTagsSearchResult: [],
            isNextStepAfterPostCreationDialogOpen: false
        } as any;
    }

    public async fia_componentWillMount() {
        const postId = this.props.history['location']['state']?this.props.history['location']['state']['postId']:null;
        if (postId) {
            this.setState({ loading: true });
            const post = await PostModel.loadPost(postId);
            this.setState({ loading: false, post })
        }
    }

    public onAnotherPost() {
        this.setState({ post: new PostModel(), isNextStepAfterPostCreationDialogOpen: false })
    }

    public async onCreateNewTag(s: string) {
        this.setState({ loading: true });
        const { hashTagsSearchResult } = this.state;
        let exist = false;
        hashTagsSearchResult.forEach((h: HashTagModel) => {
            if (h.name === s) {
                exist = true
            }
        });
        let newHashTag = null;
        if (!exist) {
            newHashTag = new HashTagModel();
            newHashTag.name = s;
            newHashTag.popularity = 0;
            await newHashTag.save();
        }
        this.setState({ loading: false });
        return newHashTag;
    }

    public async onPostSave() {
        const { post } = this.state;
        this.setState({ loading: true });
        await post.saveFullPost()
        this.setState({ loading: false, isNextStepAfterPostCreationDialogOpen: true });
    }

    public async onSearchHashTag(s: string) {
        let { hashTagsSearchResult } = this.state;
        hashTagsSearchResult = [];
        if (s) {
            hashTagsSearchResult = await HashTagModel.searchHashTag(s) as HashTagModel[]
        }
        this.setState({ hashTagsSearchResult })
    }

    public onCloseDialog(){
        this.setState({post:this.state.post, isNextStepAfterPostCreationDialogOpen:false});
    }

    public dashboard_render(): JSX.Element {
        const { post, hashTagsSearchResult, loading, isNextStepAfterPostCreationDialogOpen } = this.state;
        return <View
            accessAvailable={this.accessAvailable}
            onAnotherCreation={() => this.onAnotherPost()}
            model={post}
            loading={loading}
            onSave={() => this.onPostSave()}
            isNextStepAfterCreationDialogOpen={isNextStepAfterPostCreationDialogOpen}
            onCreateNewTag={(s: string) => this.onCreateNewTag(s)}
            // tslint:disable-next-line:jsx-no-lambda
            onBack={() => this.goBack()}
            hashTagsSearchResult={hashTagsSearchResult}
            onSearchHashTags={(s: string) => this.onSearchHashTag(s)}
            onDialogClose={()=>this.onCloseDialog()}
        />
    }
}

export default DashboardPostsAddEditController;



// WEBPACK FOOTER //
// ./src/app/dashboard/posts/addedit/DashboardPostsAddEditController.tsx